module.exports = __webpack_public_path__ + "img/copy-link.ccce7997.png";